
import { City } from "@/@types/common";
import { computed, defineComponent, ref } from "vue";
import { CitySelect } from "@/components/Common";
import { AnalysisAddress } from "@/api-server/modules/defaultServer";

export default defineComponent({
  name: "editAddress",
  components: {
    CitySelect,
  },
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const defaultProvinceObj = ref<City | null>(null);
    const defaultCityObj = ref<City | null>(null);
    const defaultCountyObj = ref<City | null>(null);
    const editFormData = computed({
      get() {
        return props.formData;
      },
      set(nv: any) {
        emit("update:formData", nv);
      },
    });
    const loading = ref(false);
    const newReceiverInfo = ref("");

    const handleCityChange = (
      provinceObj: any,
      cityObj: any,
      countyObj: any
    ) => {
      if (countyObj) {
        editFormData.value.newReceiverProvince = provinceObj.text;
        // editFormData.value.provinceCode = provinceObj.value;
        editFormData.value.newReceiverCity = cityObj.text;
        // editFormData.value.cityCode = cityObj.value;
        editFormData.value.newReceiverCounty = countyObj.text;
        // editFormData.value.districtCode = countyObj.value;
      } else {
        editFormData.value.newReceiverProvince = "";
        // editFormData.value.provinceCode = "";
        editFormData.value.newReceiverCity = "";
        // editFormData.value.cityCode = "";
        editFormData.value.newReceiverCounty = "";
        // editFormData.value.districtCode = "";
      }
    };

    const handleTrim = () => {
      newReceiverInfo.value = newReceiverInfo.value.trim();
    };
    const handleIdentify = async () => {
      if (!newReceiverInfo.value.trim()) return;
      loading.value = true;
      const { data: { data } } = await AnalysisAddress.fetch({
        address: newReceiverInfo.value.trim()
      })
      const { address = '', city = '', cityId = '', district = '', districtId = '', name = '', phone = '', province = '', provinceId = '' } = data as BUSINESS_SERVE_PLATFORM_PC.AnalysisAddressResponseData
      provinceId && (defaultProvinceObj.value = { text: province, value: provinceId })
      cityId && (defaultCityObj.value = { text: city, value: cityId })
      districtId && (defaultCountyObj.value = { text: district, value: districtId })
      address && (editFormData.value.newReceiverAddress = address)
      name && (editFormData.value.newReceiverName = name)
      phone && (editFormData.value.newReceiverPhone = phone)
      handleCityChange(defaultProvinceObj.value, defaultCityObj.value, defaultCountyObj.value)
      loading.value = false
    };
    const handleClear = () => {
      newReceiverInfo.value = "";
    };

    return {
      editFormData,
      defaultProvinceObj,
      defaultCityObj,
      defaultCountyObj,
      newReceiverInfo,
      handleCityChange,
      handleTrim,
      handleIdentify,
      handleClear,
    };
  },
});
